export const environment = {
  production: true,
  env: 'dev',
  apiUrls: {
    // api: 'https://api.ello.is',
    api: 'https://api.ello.dev.seraphic.io',
    // api: 'http://localhost:3007',
  },
};
